import { render, staticRenderFns } from "./WorkIconLabel.vue?vue&type=template&id=3df2a6ee&scoped=true"
import script from "./WorkIconLabel.vue?vue&type=script&lang=js"
export * from "./WorkIconLabel.vue?vue&type=script&lang=js"
import style0 from "./WorkIconLabel.vue?vue&type=style&index=0&id=3df2a6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df2a6ee",
  null
  
)

export default component.exports